import { FEATURE_FLAGS } from '@feature-flags/constants';
import { useFeatureFlags } from '@feature-flags/use-feature-flags';
import { useAppSelector } from '@redux/hooks';

export const useStorefrontPriceEstimator = (): boolean => {
	const vendor = useAppSelector((state) => state.vendor.vendor);
	const vendorRaw = useAppSelector((state) => state.vendor.vendorRaw);
	const featureFlags = useFeatureFlags();

	const amount = vendorRaw?.ai?.costBreakdown?.budgetRange?.price?.amount;
	const hasCostBreakdown =
		amount != null &&
		(amount.value != null || amount.min != null || amount.max != null);

	return Boolean(
		featureFlags[FEATURE_FLAGS.PRICE_ESTIMATOR] &&
			vendor?.isPaid &&
			vendor?.categoryCode === 'REC' &&
			hasCostBreakdown,
	);
};
